module.exports = __webpack_public_path__ + "media/images/recruitment/landing/icon_problem-58fd7a323971fbac2aef2f54d38d5103.svg";